var $ = jQuery;
import {bodyNoScroll} from '../utils/utilities.js';
/* eslint-disable */
import featherlight from '../libs/featherlight.js';
/* eslint-enable */


function init() {
  if($('#expert__contact-form').length > 0) {
    $('.expert-bio-card__request').featherlight('#expert__contact-form', {
      otherClose: '.event__close-modal',
      root: '.page-node-type-person',
      variant: 'expert__request',
      afterOpen: function(event) {
        $('.event__close-modal').focus();
        bodyNoScroll();
      },
      beforeOpen: function() {
        window.getFormExpert();
      },
      afterClose: function() {
        window.removeFormExpert();
        bodyNoScroll();
      }
    });
  }
}

export { init as init };
